const e=(e=``)=>Object.freeze([`org`,e]);export{e as createOrgScope};
//# sourceMappingURL=create-org-scope.mjs.map